import React, {Component} from 'react';
import {Modal, Button, Spin} from 'antd';
import request from 'superagent';

class AlertDetailModalAnt extends Component {
    state = {
        loading: false,
        visible: false,
        detailDate: {}
    }

    showModal = () => {
        this.setState({
            visible: true
        });
        this.fetch(this.props.row);
    }

    fetch = (params = {}) => {
        this.setState({loading: true});
        let url = '';
        if (this.props.from === 'service') {
            url = '/api/dashboard/service/alert';
        } else if (this.props.from === 'platform') {
            url = '/api/dashboard/platform/alert';
        } else if(this.props.from === 'service_pdms'){
            url = '/api/dashboard/service/alert/pdms';
        }
        if (params.tid === '') {
            delete params.tid;
        }
        console.log('params:', params);
        request.get(url)
            .query(params)
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    let data = response.body;
                    this.setState({
                        loading: false,
                        detailDate: data
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    render() {
        const cell = this.props.cell;
        const {visible, loading} = this.state;
        const detailDate = this.state.detailDate;

        return (
            <div>
                <a href="#" onClick={this.showModal}>{cell}</a>
                <Modal visible={visible} title={'Alert Detail'} loading={loading} onCancel={this.handleCancel} maskClosable={false} width={800}
                       footer={[
                           <Button key="back" size="large" onClick={this.handleCancel}>Close</Button>,
                       ]}>
                    <div>
                        <div style={{textAlign: 'center'}}>
                            <Spin spinning={loading} tip="Loading..."/>
                        </div>
                        <div style={{display: loading ? 'none' : 'block'}}>
                            <pre style={{height: 300, overflow: 'auto'}}>{JSON.stringify(detailDate, null, 2) }</pre>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}
export default AlertDetailModalAnt;


// WEBPACK FOOTER //
// ./src/modules/dashboard/AlertDetailModalAnt.js